/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CalculatedInterestDto } from '../models/CalculatedInterestDto';
import type { CalculateFixedDepositInterestCommand } from '../models/CalculateFixedDepositInterestCommand';
import type { CloseFixedDepositCommandPayload } from '../models/CloseFixedDepositCommandPayload';
import type { CreateFixedDepositCommand } from '../models/CreateFixedDepositCommand';
import type { DeleteFixedDepositCommandPayload } from '../models/DeleteFixedDepositCommandPayload';
import type { EditFixedDepositPayload } from '../models/EditFixedDepositPayload';
import type { FixedDepositDto } from '../models/FixedDepositDto';
import type { FixedDepositDtoPaginatedResult } from '../models/FixedDepositDtoPaginatedResult';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class FixedDepositsService {
    /**
     * @param requestBody
     * @returns string Created
     * @throws ApiError
     */
    public static postApiFixedDeposits(
        requestBody?: CreateFixedDepositCommand,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/FixedDeposits',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param pageNumber
     * @param pageSize
     * @param filterByBank
     * @param filterByIssuanceDateStart
     * @param filterByIssuanceDateEnd
     * @param filterByStartDateStart
     * @param filterByStartDateEnd
     * @param filterByEndDateStart
     * @param filterByEndDateEnd
     * @param filterByCutOffDateStart
     * @param filterByCutOffDateEnd
     * @param filterByStatus
     * @param sortBy
     * @param sortOrder
     * @returns FixedDepositDtoPaginatedResult OK
     * @throws ApiError
     */
    public static getApiFixedDeposits(
        pageNumber?: number,
        pageSize?: number,
        filterByBank?: Array<string>,
        filterByIssuanceDateStart?: string,
        filterByIssuanceDateEnd?: string,
        filterByStartDateStart?: string,
        filterByStartDateEnd?: string,
        filterByEndDateStart?: string,
        filterByEndDateEnd?: string,
        filterByCutOffDateStart?: string,
        filterByCutOffDateEnd?: string,
        filterByStatus?: Array<string>,
        sortBy?: string,
        sortOrder?: string,
    ): CancelablePromise<FixedDepositDtoPaginatedResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/FixedDeposits',
            query: {
                'PageNumber': pageNumber,
                'PageSize': pageSize,
                'FilterByBank': filterByBank,
                'FilterByIssuanceDateStart': filterByIssuanceDateStart,
                'FilterByIssuanceDateEnd': filterByIssuanceDateEnd,
                'FilterByStartDateStart': filterByStartDateStart,
                'FilterByStartDateEnd': filterByStartDateEnd,
                'FilterByEndDateStart': filterByEndDateStart,
                'FilterByEndDateEnd': filterByEndDateEnd,
                'FilterByCutOffDateStart': filterByCutOffDateStart,
                'FilterByCutOffDateEnd': filterByCutOffDateEnd,
                'FilterByStatus': filterByStatus,
                'SortBy': sortBy,
                'SortOrder': sortOrder,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns string OK
     * @throws ApiError
     */
    public static putApiFixedDeposits(
        id: string,
        requestBody?: EditFixedDepositPayload,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/FixedDeposits/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param id
     * @returns FixedDepositDto OK
     * @throws ApiError
     */
    public static getApiFixedDeposits1(
        id: string,
    ): CancelablePromise<FixedDepositDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/FixedDeposits/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns string OK
     * @throws ApiError
     */
    public static deleteApiFixedDeposits(
        id: string,
        requestBody?: DeleteFixedDepositCommandPayload,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/FixedDeposits/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Export all fixed deposits after filtering and sorting
     * @param filterByBank
     * @param filterByIssuanceDateStart
     * @param filterByIssuanceDateEnd
     * @param filterByStartDateStart
     * @param filterByStartDateEnd
     * @param filterByEndDateStart
     * @param filterByEndDateEnd
     * @param filterByCutOffDateStart
     * @param filterByCutOffDateEnd
     * @param filterByStatus
     * @param selectedFDs
     * @param sortBy
     * @param sortOrder
     * @param unselectedFDs
     * @param timeZone
     * @returns binary OK
     * @throws ApiError
     */
    public static getApiFixedDepositsExport(
        filterByBank?: Array<string>,
        filterByIssuanceDateStart?: string,
        filterByIssuanceDateEnd?: string,
        filterByStartDateStart?: string,
        filterByStartDateEnd?: string,
        filterByEndDateStart?: string,
        filterByEndDateEnd?: string,
        filterByCutOffDateStart?: string,
        filterByCutOffDateEnd?: string,
        filterByStatus?: Array<string>,
        selectedFDs?: Array<string>,
        sortBy?: string,
        sortOrder?: string,
        unselectedFDs?: Array<string>,
        timeZone?: string,
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/FixedDeposits/export',
            query: {
                'FilterByBank': filterByBank,
                'FilterByIssuanceDateStart': filterByIssuanceDateStart,
                'FilterByIssuanceDateEnd': filterByIssuanceDateEnd,
                'FilterByStartDateStart': filterByStartDateStart,
                'FilterByStartDateEnd': filterByStartDateEnd,
                'FilterByEndDateStart': filterByEndDateStart,
                'FilterByEndDateEnd': filterByEndDateEnd,
                'FilterByCutOffDateStart': filterByCutOffDateStart,
                'FilterByCutOffDateEnd': filterByCutOffDateEnd,
                'FilterByStatus': filterByStatus,
                'SelectedFDs': selectedFDs,
                'SortBy': sortBy,
                'SortOrder': sortOrder,
                'UnselectedFDs': unselectedFDs,
                'TimeZone': timeZone,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns string OK
     * @throws ApiError
     */
    public static patchApiFixedDepositsClose(
        id: string,
        requestBody?: CloseFixedDepositCommandPayload,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/FixedDeposits/{id}/close',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns CalculatedInterestDto OK
     * @throws ApiError
     */
    public static patchApiFixedDepositsCalculateInterest(
        requestBody?: CalculateFixedDepositInterestCommand,
    ): CancelablePromise<CalculatedInterestDto> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/FixedDeposits/calculateInterest',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
